import { forwardRef, type SVGProps } from 'react';

export const Group = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg fill="none" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>
    <path
      d="M2.076 6.82l1.52 9.81a.75.75 0 00.742.635h15.245a.75.75 0 00.74-.63l1.604-9.854a.2.2 0 00-.307-.2l-5.044 3.31-4.41-6.615a.2.2 0 00-.333 0L7.17 10.23 2.394 6.629a.2.2 0 00-.318.19z"
      fill="currentColor"
    />
    <path
      d="M21.927 6.781l-1.604 9.854a.75.75 0 01-.74.63h-3.091l-5.208-3.899L21.62 6.582a.2.2 0 01.307.2z"
      fill="#fff"
      fillOpacity=".25"
    />
    <path
      d="M4.338 17.265H16.49L2.394 6.629a.2.2 0 00-.318.19l1.52 9.81a.75.75 0 00.742.636z"
      fill="#fff"
      fillOpacity=".55"
    />
    <path
      d="M19.47 18.282H4.602a.5.5 0 00-.496.562l.34 2.689a.5.5 0 00.496.437l14.128.003a.5.5 0 00.495-.426l.401-2.692a.5.5 0 00-.494-.573z"
      fill="currentColor"
    />
  </svg>
));
